<div class="container text-center">
  <div class="row">
    <div class="col-sm-12">
      <img src="assets/img/Itsme_logo_hexa_pos_rgb.jpg" style="width:100%; max-width: 200px">
      <h1>{{'ITSME.LOADING' | translate}}</h1>
    </div>
  </div>
</div>
